/*** IMPORTS FROM imports-loader ***/
var define = false;

/*** IMPORTS FROM imports-loader ***/


'use strict';
const Logger = require('../logger');

const AbstractMessageHandler = require('./abstract_message_handler');

class MessageHandlerFit extends AbstractMessageHandler {

  get MESSAGE_EVENT() {
    return 'fit';
  }

  handleMessage(message) {
    const flipperServicePromise = this.window.e.utils.getFlipperService();
    flipperServicePromise.then(flipperService => {
      if (flipperService.isOn('ui_integration_remove_fit')) { return; }

      Logger.sendLog('fit called');
      let $iframe = $(this.getIntegrationIframe(message.source.integration_instance_id));
      const height = $iframe.height() + (document.body.offsetHeight - document.body.scrollHeight);

      $iframe
        .height(height)
        .parent()
        .height(height);
    });
  }
}

module.exports = MessageHandlerFit;




/*** EXPORTS FROM exports-loader ***/



/** WEBPACK FOOTER **
 ** ./message_handler/fit.js
 **/